import React from 'react';
import { NavLink ,useNavigate} from 'react-router-dom';
import { 
  LayoutDashboard, ShoppingBag, Layers, Users, 
  Settings, LogOut, Hammer ,GalleryHorizontalIcon,Contact,BookOpen,
} from 'lucide-react';




const AdminSidebar = ({ isOpen, isMobile, closeMobile }) => {
  const navigate = useNavigate(); 
    // --- LOGOUT LOGIC ---
  const handleLogout = () => {
    if (window.confirm("Are you sure you want to end your session?")) {
      // 1. Remove the token
      localStorage.removeItem('sksnToken');
      
      // 2. Redirect to Login page
      navigate('/adminlogin');
      
      // 3. Optional: reload to clear any remaining state
      // window.location.reload(); 
    }
  };
  const menuItems = [
    { name: "Add Slider", icon: <LayoutDashboard size={20} />, path: "/admin/addslider" },
    { name: "Add Products", icon: <ShoppingBag size={20} />, path: "/admin/additem" },
    { name: "Add Categories", icon: <Layers size={20} />, path: "/admin/category" },
   { name: "Trade", icon: <BookOpen size={20} />, path: "/admin/trade" },
        { name: "Inquiries", icon: <Contact size={20} />, path: "/admin/inquiries" },
        { name: "Infrastructure", icon: <GalleryHorizontalIcon size={20} />, path: "/admin/addgallery" },
    { name: "Change Password", icon: <Users size={20} />, path: "/admin/changepassword" },


  ];

  return (
    <aside className={`admin-sidebar ${isOpen ? 'open' : 'closed'}`}>
      
      {/* Logo Area */}
      <div className="sidebar-header">
        <div className="sidebar-logo-icon">
          <Hammer size={24} color="#C5A059" />
        </div>
        <h2 className="sidebar-brand">Sohani<span>Admin</span></h2>
      </div>

      {/* Navigation Links */}
      <nav className="sidebar-nav">
        <ul>
          {menuItems.map((item, index) => (
            <li key={index}>
              <NavLink 
                to={item.path} 
                className={({ isActive }) => isActive ? "sidebar-link active" : "sidebar-link"}
                onClick={isMobile ? closeMobile : undefined}
              >
                <span className="link-icon">{item.icon}</span>
                <span className="link-text">{item.name}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* Logout Area */}
      <div className="sidebar-footer">
        <button className="logout-btn" onClick={handleLogout}>
          <LogOut size={20} />
          <span className="link-text">Logout</span>
        </button>
      </div>
    </aside>
  );
};

export default AdminSidebar;